/**
 * Temporary feature: Finder criterion carousel on the MacBook PLP.
 * Remove together with `FF_PLP_FINDER_ENABLED` once development is finished.
 */
export const ALLOWED_PLP_UUIDS: string[] = [
  // MacBook PLP prod
  'a059fa0c-b88d-4095-b6a2-dcbeb9dd5b33',
  // MacBook PLP preprod
  'd72d58f6-185e-429e-bb1e-4d5ba5262e79',
  // MacBook PLP prod FR
  '297f69c7-b41c-40dd-aa9b-93ab067eb691',
  // MacBook PLP preprod FR
  'fa83a4e3-3865-4f24-bb0e-6500ba4fec33',
  '4ece5537-06dd-4c57-a3f5-2a482d1cfb5c',
] as const
